import cn from "classnames";
import { FC } from "react";
import { Trans, useTranslation } from "react-i18next";
import "./closing-notice-modal.sass";

type Props = {
  className?: string;
};

const ClosingNoticeModal: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={cn(className, "closing-notice-modal")}>
      <div className="closing-notice-modal__title">
        <Trans i18nKey="closingNotice.title">
          <span className="_g-text-active-lighter">closing down</span>
        </Trans>
      </div>
      <div className="closing-notice-modal__desc">{t("closingNotice.desc")}</div>
    </div>
  );
};

export default ClosingNoticeModal;
